var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6a6 6 0 016-6h158a6 6 0 016 6v73a6 6 0 01-6 6H6a6 6 0 01-6-6V6z",
    fill: "url(#visa_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.038h170v12.143H0V11.038z",
    fill: "#0F0F0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.822 44.596l1.644-10.197h2.627L21.45 44.596h-2.628m12.158-9.948a6.496 6.496 0 00-2.355-.428c-2.598 0-4.426 1.383-4.441 3.365-.017 1.465 1.305 2.283 2.3 2.77 1.025.5 1.368.819 1.364 1.265-.007.683-.817.996-1.572.996-1.052 0-1.61-.154-2.475-.535l-.338-.162-.367 2.282c.612.284 1.748.53 2.927.544 2.76 0 4.554-1.367 4.575-3.483.01-1.162-.69-2.043-2.207-2.77-.918-.473-1.481-.786-1.475-1.265 0-.424.476-.877 1.505-.877a4.608 4.608 0 011.967.391l.235.117.356-2.21",
    fill: "#04258F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.688 34.407h2.03l2.127 10.19h-2.439s-.24-1.172-.32-1.528l-1.849-.003-1.516-.002c-.102.276-.552 1.533-.552 1.533h-2.76l3.902-9.345c.276-.664.747-.845 1.377-.845zm-.164 3.723s-.829 2.264-1.047 2.85h2.181c-.103-.51-.608-2.943-.608-2.943l-.177-.88c-.07.203-.168.472-.243.676a6.49 6.49 0 00-.106.297z",
    fill: "#04258F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.617 34.405l-2.571 6.952-.276-1.413c-.479-1.628-1.97-3.393-3.64-4.277l2.353 8.917 2.781-.001 4.138-10.178h-2.785",
    fill: "#04258F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.659 34.401H7.421l-.035.212c3.297.844 5.478 2.883 6.383 5.334l-.92-4.685c-.16-.647-.62-.838-1.191-.86",
    fill: "#04258F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145.766,
    cy: 60.767,
    r: 16.61,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.601 55.457H8.829a1.856 1.856 0 00-1.856 1.856v6.676c0 1.026.83 1.857 1.856 1.857h115.4a17.937 17.937 0 01-.593-4.58c0-2.024.338-3.975.965-5.809z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.935 65.901h-1.271v-8.428l-2.55.936v-1.148l3.623-1.36h.198v10zm10.227 0h-6.522v-.909l3.446-3.828c.51-.579.861-1.048 1.052-1.408.196-.365.294-.74.294-1.128 0-.52-.157-.946-.471-1.278-.315-.333-.734-.5-1.258-.5-.629 0-1.119.18-1.47.54-.346.356-.519.853-.519 1.49h-1.265c0-.915.294-1.656.882-2.22.592-.566 1.383-.848 2.372-.848.925 0 1.656.243 2.194.731.538.483.807 1.128.807 1.934 0 .98-.624 2.147-1.873 3.5l-2.666 2.892h4.997v1.032zm3.179-5.591h.95c.597-.01 1.066-.167 1.408-.472.342-.305.513-.718.513-1.237 0-1.167-.581-1.75-1.743-1.75-.547 0-.985.157-1.313.471-.324.31-.485.723-.485 1.238h-1.265c0-.789.287-1.443.861-1.962.579-.524 1.313-.786 2.202-.786.938 0 1.674.248 2.208.745.533.496.799 1.187.799 2.07 0 .434-.141.853-.423 1.259a2.518 2.518 0 01-1.142.909c.547.173.968.46 1.265.861.3.401.451.891.451 1.47 0 .893-.292 1.602-.875 2.126-.584.524-1.342.786-2.277.786-.934 0-1.695-.253-2.283-.759-.583-.506-.875-1.173-.875-2.003h1.272c0 .524.171.944.512 1.258.342.315.8.472 1.374.472.611 0 1.078-.16 1.402-.479.323-.319.485-.777.485-1.374 0-.578-.178-1.023-.533-1.333-.356-.31-.868-.47-1.538-.478h-.95V60.31z",
    fill: "#4D4D4D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visa_svg__a",
    x1: 0,
    y1: -13.177,
    x2: 136.121,
    y2: 50.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F2F2"
  })))));
}
export default SvgVisa;